<script setup lang="ts">
import { getEnv } from '@/libs/env'
import { RouteName } from '@/router/routeNames'
import { useRoute, useRouter, type RouteLocationNormalizedLoaded } from 'vue-router'
import log from 'loglevel'
import PageContent from '@/components/PageContent.vue'
import LoadingIndicator from '@/components/LoadingIndicator.vue'

// List of origins allowed for redirect.
const ALLOWED_ORIGINS = [getEnv('ambassadorsUrl')]

const route = useRoute()
const router = useRouter()

function maybeAllowedUrlFromUnsafeQuery(queryUrl: string): string | null {
  const urlEncoded = String(queryUrl)
  let urlDecodedRaw
  let urlDecoded

  try {
    urlDecodedRaw = decodeURIComponent(urlEncoded)
    urlDecoded = new URL(urlDecodedRaw)
  } catch (error: unknown) {
    return null
  }

  if (ALLOWED_ORIGINS.includes(urlDecoded.origin)) {
    log.debug('redirect to allowed origin:', urlDecoded.origin)
    return urlDecodedRaw
  } else {
    log.debug(
      'redirect to disallowed origin:',
      urlDecoded.origin,
      'where allowed origins are',
      ALLOWED_ORIGINS
    )
    return null
  }
}

const getUrlQuery = (route: RouteLocationNormalizedLoaded): string => {
  const url = route.query['url']
  // In scenario where user passed multiple `url` params, fallback to empty
  // string for simplicity.
  if (Array.isArray(url)) return ''
  return url?.toString() ?? ''
}

const unsafeUrlQuery = getUrlQuery(route)

log.debug('redirect page received url param:', unsafeUrlQuery)

const maybeRedirectUrl = maybeAllowedUrlFromUnsafeQuery(unsafeUrlQuery)

if (maybeRedirectUrl) {
  log.debug('performing redirect to', maybeRedirectUrl)
  window.location.href = maybeRedirectUrl
} else {
  log.debug('fallback redirect to missions list')
  router.push({ name: RouteName.Missions })
}
</script>
<template>
  <div class="max-w-md m-auto min-h-full">
    <PageContent>
      <LoadingIndicator class="mt-[33%]"></LoadingIndicator>
    </PageContent>
  </div>
</template>
